import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ActivityService} from 'src/app/services/activity.service';
import {AgendaService} from 'src/app/services/agenda.service';
import {MemberService} from 'src/app/services/member.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';

@Component({
    selector: 'app-event-staff-dialog',
    templateUrl: './event-staff-dialog.component.html',
    styleUrls: ['./event-staff-dialog.component.scss'],
    entryComponents: [
        ConfirmComponent
    ],
})
export class EventStaffDialogComponent implements OnInit {

    public roleForm: FormGroup;
    public members: any[] = []
    public isEdit: boolean;

    public spinner: boolean;

    constructor (
        public matDialogRef: MatDialogRef<EventStaffDialogComponent>,
        private fb: FormBuilder,
        private _memberService: MemberService,
        public _agendaService: AgendaService,
        public _activityService: ActivityService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

       console.log("this.data: " + JSON.stringify(this.data))

        if(this.data.id){
            this.isEdit = true;
        } else {
            this.isEdit = false;
        }
        this.initializeAutoCompletes(this.data);
    }

    ngOnInit () {
       
    }


    //
    // AUTOCOMPLETES //////////////////

    initializeAutoCompletes (data) {

        this.roleForm = this.fb.group({
            id: new FormControl(data.id),
            role_id: new FormControl(data.role_id),
            role_name: new FormControl(data.role_name),
            member: new FormControl(data.member_name),
            state: new FormControl(data.member_state),
            country: new FormControl(data.member_country),
            requireConfirm: new FormControl(data.requireConfirm),
            requireSchedule: new FormControl(data.requireSchedule),
        });

        this.roleForm.controls.member.valueChanges.subscribe(val => {
            if (val != undefined) this.updateMemberSearchList(val);
        })
    }

    cleanMemberSearch () {
        this.members = []
    }

    updateMemberSearchList (val) {

        if (val.length > 3) {
            this._memberService.selectStaffStartAt(val)
                .subscribe((result) => {

                    this.members = []

                    result.forEach((item) => {

                      const deleted = item.data().deleted ? true : false

                      if(!deleted){

                        this.members.push({
                            "id": item.id,
                            "name": item.data().name,
                            "state": item.data().state,
                            "country": item.data().country,
                            "email": item.data().email,
                            "cellPhone": item.data().cellPhone
                        })

                      }

                    })

                })
        }
    }

    displayMember (value) {

        if ((value !== null) && (value !== undefined) && (value !== "")) {
            return value.name + " - " + value.state + " - " + value.country;
        } else {
            return "";
        }

    }


}
